import { createActionCreators } from "../utils/actionCreators";

export const {
    request: getJobProfileRequest,
    success: getJobProfileSuccess,
    failure: getJobProfileFailure
} = createActionCreators('GET_JOBPROFILE');

export const {
    request: updateJobProfileRequest,
    success: updateJobProfileSuccess,
    failure: updateJobProfileFailure
} = createActionCreators('UPDATE_JOBPROFILE');
